import React, { useState, useRef, useEffect } from "react";
import "./ScheduleHeader.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { solid } from "@fortawesome/fontawesome-svg-core/import.macro";
import ScheduleModal from "../../modals/ScheduleModal";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { slice1Actions } from "../../../store/reducer";
import EventEdit from "../../modals/EventEdit";
import MenuModal from "../../modals/MenuModal";
import MoveEvents from "../../modals/MoveEvents";
import PromptModal from "../../modals/PromptModal";
import AlertModal from "../../modals/AlertModal";
import RecalculateDialog from "../../modals/RecalculateDialog";
import { DateTime } from "luxon";
import Appointment from "../../../Models/Event";
import MultiSelectModal from "../../modals/MultiSelectModal";
import { urlSchemeToFunctions } from "../../../CommonWeb/Common";
import PlaceMenu from "../../../CommonWeb/PlaceMenu";
import Place from "../../../Models/Place";
import Common from "../../../Common/Common";
import ImageDialog from "../../modals/ImageDialog";
import Schedule from "../../../Models/Schedule";
import FillIdleTimeModal from "../../modals/FillIdleTimeModal";

const ScheduleHeader = (props) => {
  const [scheduleModal, setScheduleModal] = useState(false);
  const [ShowEventEdit, setShowEventEdit] = useState(false);
  const [EventEditMode, setShowEventMode] = useState("MODIFY");
  const [EventEditWhere, setShowEventWhere] = useState("after");
  const [MenuModalShow, setMenuModalShow] = useState(false);
  const [MenuModalImage, setMenuModalImage] = useState(null);
  const [MenuModalList, setMenuModalList] = useState([]);
  const [MenuModalHeading, setMenuModalHeading] = useState("");
  const [MenuModalPlace, setMenuModalPlace] = useState(null);

  const [PromptModalShow, setPromptModalShow] = useState(false);
  const [PromptModalTitle, setPromptModalTitle] = useState("Enter Value");
  const [PromptModalMessage, setPromptModalMessage] = useState("");
  const [PromptModalButtons, setPromptModalButtons] = useState([]);
  const [PromptModalInputs, setPromptModalInputs] = useState([]);
  const [PromptModalArea, setPromptModalArea] = useState(false);

  const [RecalcDialogShow, setRecalcDialogShow] = useState(false);

  // Lets the mobile-mode command palette (MobileBottomNavBar.js) open this
  // component's own Schedule Menu after navigating here, since the palette
  // can't call this component's local functions directly.
  const scheduleMenuRef = useRef(null);
  useEffect(() => {
    scheduleMenuRef.current = scheduleMenu;
  });

  // Lets "N more options in Advanced Mode" hints reopen the same menu after
  // toggling, so newly-revealed items are immediately visible. Refreshed
  // every render so it always sees the just-updated advancedMode value.
  const scheduleNameClickedMenuRef = useRef(null);
  useEffect(() => {
    scheduleNameClickedMenuRef.current = scheduleNameClickedMenu;
  });

  useEffect(() => {
    const handler = () => { if (scheduleMenuRef.current) scheduleMenuRef.current(); };
    window.addEventListener("openScheduleMenu", handler);
    return () => window.removeEventListener("openScheduleMenu", handler);
  }, []);
  const [AlertModalShow, setAlertModalShow] = useState(false);
  const [AlertModalTitle, setAlertModalTitle] = useState("");
  const [AlertModalMessage, setAlertModalMessage] = useState("");
  const [AlertModalButtons, setAlertModalButtons] = useState([]);

  const [Mode, setMode] = useState("move_day");
  const [ParamDate] = useState(null);
  const [MoveEventsShow, setMoveEventsShow] = useState(false);

  const [MultiselectItems, setMultiselectItems] = useState([]);
  const [MultiselectSelectedItems, setMultiselectSelectedItems] = useState([]);
  const [MultiselectMode, setMultiselectMode] = useState("uni");
  const [MultiselectTitle, setMultiselectTitle] = useState("Select");
  const [MultiselectSearchText] = useState("");
  const [ShowMultiselect, setShowMultiselect] = useState(null);
  const [ScheduleAction, setScheduleAction] = useState("select");

  const [playState, setPlayState] = useState("Stopped");
  // A ref, not useState — setInterval's own callback (playEvent) closes over
  // whatever value this held at the moment startPlayingItinerary ran, and
  // that closure is what actually calls stopPlayingItinerary/clearInterval
  // later (both on manual Stop and on auto-stop when the trip finishes). If
  // this were state, that closure would keep reading the id from BEFORE
  // setPlayTimer(id) ever committed (still null on the very first Play),
  // so clearInterval(null) was a no-op — the interval kept running forever
  // as a zombie with no button able to reach it anymore, however many times
  // Play/Stop were pressed afterward. A ref is always read fresh, so every
  // caller (manual Stop, the end-of-trip auto-stop check, and a future
  // Play's own start) clears the exact interval that's actually running.
  const playTimerRef = useRef(null);
  // Unmount safety — ScheduleHeader has two separate JSX mount points in
  // App.js (mobile-mode/desktop), so switching modes mid-replay could
  // otherwise leave the interval running with no component left to stop it.
  useEffect(() => () => clearInterval(playTimerRef.current), []);

  const [ShowItinSettings, setShowItinSettings] = useState(false);
  const [ItinAction, setItinAction] = useState("copy");
  // Cover image for "Copy to Trip Itinerary": "auto" = the guide's own image or
  // its first place photo, "none" = no image at all (remembered in the guide's
  // itinerary settings), "custom" = a photo picked here (also saved as the
  // guide's info image so later copies use it).
  const [CoverMode, setCoverMode] = useState("auto");
  const [CoverCustomUrl, setCoverCustomUrl] = useState("");
  const [ShowCoverImageDialog, setShowCoverImageDialog] = useState(false);
  const [ItinSettings, setItinSettings] = useState({ place_name: true, info: true, photo: true, directions: true, eventBody: false, weather: true, climate: true });

  const dispatch = useDispatch();
  let ScheduleName = useSelector((state) => state.ScheduleName);
  let ScheduleNames = useSelector((state) => state.ScheduleNames);
  let MobileMode = useSelector((state) => state.MobileMode);
  let CurrentAppScreen = useSelector((state) => state.CurrentAppScreen);
  let AppScreenStack = useSelector((state) => state.AppScreenStack);
  let GuideEditMode = useSelector((state) => state.GuideEditMode);
  let GuideSettings = useSelector((state) => state.GuideSettings);
  let user_info = useSelector((state) => state.user_info);
  let EventSearchText = useSelector((state) => state.EventSearchText);

  // Guide Settings' "Weather link"/"Climate link" toggles are the default
  // checked-state for this checklist — previously this always opened with
  // both hardcoded true regardless of Guide Settings, so turning them off
  // there had no effect on "Copy to Trip Itinerary"/"Display as Itinerary".
  // Read at open time (not as the useState initializer) since GuideSettings
  // can change between opens without this component remounting.
  const openItinSettings = (action) => {
    setItinSettings((s) => ({
      ...s,
      weather: GuideSettings.itinerary?.weather === true,
      climate: GuideSettings.itinerary?.climate === true,
    }));
    setItinAction(action);
    setCoverMode(GuideSettings.itinerary?.cover === false ? "none" : "auto");
    setCoverCustomUrl("");
    setShowItinSettings(true);
  };

  // Lets other parts of the UI (the Edit menu above the itinerary) open this
  // same "Copy to Trip Itinerary" dialog. Re-registered when GuideSettings
  // changes so openItinSettings reads the current Weather/Climate defaults.
  useEffect(() => {
    const open = () => openItinSettings("copy");
    window.addEventListener("andiamo-open-itinerary-copy", open);
    return () => window.removeEventListener("andiamo-open-itinerary-copy", open);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [GuideSettings]);
  let HideSchedule = useSelector((state) => state.HideSchedule);
  let ScheduleDndEnabled = useSelector((state) => state.ScheduleDndEnabled);
  let todayActive = useSelector((state) => state.TodayMode);

  let SearchResultsPlacesList = useSelector((state) => state.SearchResultsPlacesList);
  let PlayEventsIndex = useSelector((state) => state.PlayEventsIndex);
  const PlayEventsIndexRef = useRef(PlayEventsIndex);
  useEffect(() => { PlayEventsIndexRef.current = PlayEventsIndex; }, [PlayEventsIndex]);
  let schedule = useSelector((state) => state.schedule);
  const advancedMode = user_info?.advanced_mode === "On";
  let GuideFormat = useSelector((state) => state.GuideFormat);

  const handleSearChanged = (event) => {
    //console.log(event.target.value);
    dispatch(slice1Actions.setEventSearchText({ value: event.target.value }));
    dispatch(slice1Actions.setGuide({ guide: null }));
  };

  function handleAddEventA() {
    setShowEventMode("ADD");
    setShowEventWhere("end");
    setShowEventEdit(true);
  }

  const scheduleNameClicked = (event) => {
    if (GuideSettings.click_behavior !== "custom" || event.detail === 2) {
      scheduleNameClickedMenu();
      return;
    }
    if (GuideSettings.schedule.menu === true) scheduleNameClickedMenu();
    if (GuideSettings.schedule.itinerary === true) {
      const htmlString = window.guide_obj.createHTMLItinerary(ScheduleName, null);
      dispatch(slice1Actions.setHTMLTitle({ value: "Itinerary" }));
      dispatch(slice1Actions.setHTMLToSHow({ value: htmlString }));
      dispatch(slice1Actions.setShowHTMLReader({ value: true }));
      window.location.href = "#home-start";
      var homeDiv = document.getElementById("home-content-start");
      if (MobileMode) dispatch(slice1Actions.setCurrentAppScreen({ value: "Home" }));
      else if (homeDiv) homeDiv.scrollIntoView();
    }
    if (GuideSettings.schedule.center === true) {
      const AllScheduledPlaces = window.guide_obj.getAllScheduledPlaces(ScheduleName);
      if (AllScheduledPlaces.length !== 0) {
        dispatch(slice1Actions.ClearAllFilters());
        dispatch(slice1Actions.centerMapToPlaces({ value: AllScheduledPlaces }));
        if (MobileMode) dispatch(slice1Actions.setCurrentAppScreen({ value: "Map" }));
        else window.location.href = "#map-start";
      }
      dispatch(slice1Actions.setGuide({ guide: null, fitToBounds: true }));
    }
    if (GuideSettings.schedule.filter === true) {
      filterBySchedule(ScheduleName);
      // const AllScheduledPlaces = window.guide_obj.getAllScheduledPlaces(ScheduleName);
      // let hiddenPlacesToShow = [];
      // AllScheduledPlaces.forEach((p) => {
      //   if (p.Hidden === true) hiddenPlacesToShow.push(p);
      // });
      // dispatch(slice1Actions.ClearAllFilters());
      // dispatch(slice1Actions.setShowHiddenPlace({ value: hiddenPlacesToShow }));
      // dispatch(slice1Actions.SetPlacesFilter({ value: AllScheduledPlaces }));
      dispatch(slice1Actions.setGuide({ guide: null, fitToBounds: true }));
      window.location.href = "#map-start";
    }
  };

  const filterBySchedule = (_ScheduleName) => {
    dispatch(slice1Actions.ClearAllFilters());
    dispatch(slice1Actions.SetSchedulesFilter({ value: [{ label: _ScheduleName }] }));
    //dispatch(slice1Actions.setGuide({ guide: null, fitToBounds: true }));
    //window.location.href = "#map-start";
  };

  const scheduleNameClickedMenu = () => {
    const buildMenuList = (advancedMode) => [
      {
        label: "Choose Schedule",
        method: () => handleChooseSchedule("select"),
        icon: null,
        visible: ScheduleNames.length > 1,
        info: "Choose a different schedule to display. A guide can have multiple schedules, e.g. 'Paris in One Day', 'Paris in Two Days', etc.",
      },
      {
        label: "Delete Schedule",
        method: () => handleChooseSchedule("delete"), //handleDeleteSchedule,
        icon: null,
        visible: advancedMode, //GuideEditMode && ScheduleNames.length > 1,
        info: "Delete the current schedule",
      },
      {
        label: "Add Schedule",
        method: handleAddSchedule,
        icon: null,
        visible: GuideEditMode && advancedMode,
        info: "Add a new schedule",
      },
    ];
    let menuList = buildMenuList(advancedMode);
    if (!advancedMode) {
      const hiddenCount = buildMenuList(true).filter((i) => i.visible).length - menuList.filter((i) => i.visible).length;
      if (hiddenCount > 0) {
        menuList = [
          ...menuList,
          {
            label: `${hiddenCount} more option${hiddenCount === 1 ? "" : "s"} in Advanced Mode`,
            method: () => {
              window.dispatchEvent(new CustomEvent("toggleAdvancedMode"));
              setTimeout(() => { if (scheduleNameClickedMenuRef.current) scheduleNameClickedMenuRef.current(); }, 350);
            },
            icon: null,
            visible: true,
            highlight: true,
            info: "Turn on Advanced Mode in Settings to see these options.",
          },
        ];
      }
    }

    //({ value: _MenuModalArgs }));
    setMenuModalList(menuList);
    setMenuModalHeading("Schedules Menu");
    setMenuModalImage(<FontAwesomeIcon icon={solid("user")} />);
    setMenuModalPlace(null);
    setMenuModalShow(true);
  };

  const scheduleMenu = () => {
    const buildMenuList = (advancedMode) => [ {
        label: "Choose Schedule",
        method: () => handleChooseSchedule("select"),
        icon: null,
        visible: ScheduleNames.length > 1,
        info: "Choose a different schedule to display. A guide can have multiple schedules, e.g. 'Paris in One Day', 'Paris in Two Days', etc.",
      },
      {
        label: "Delete Schedule",
        method: () => handleChooseSchedule("delete"), //handleDeleteSchedule,
        icon: null,
        visible: advancedMode, //GuideEditMode && ScheduleNames.length > 1,
        info: "Delete the current schedule",
      },
      {
        label: "Add Schedule",
        method: handleAddSchedule,
        icon: null,
        visible: GuideEditMode && advancedMode,
        info: "Add a new schedule",
      },
      {
        // Swapped gating with "Copy to Trip Itinerary" below 2026-10-05 —
        // user's call: viewing the itinerary read-only is the niche action
        // here, copying it onto the guide's Home page is the one a
        // beginner's more likely to want.
        label: "Display as Itinerary",
        method: () => { openItinSettings("show"); setMenuModalShow(false); },
        icon: null,
        visible: advancedMode,
        info: "Show the selected itinerary in document format (HTML).",
      },
      {
        label: "Copy to Trip Itinerary",
        method: () => { openItinSettings("copy"); setMenuModalShow(false); },
        icon: null,
        visible: true,
        info: "Copy the selected itinerary to the Home page.",
      },
      {
        label: "Change Start Date",
        method: handleChangeStartDay,
        icon: null,
        visible: GuideEditMode,
        info: "Changes the starting date/time of the entire schedule, i.e. all events for all days.",
        videoKey: "move-events",
      },
      {
        label: "Copy Events to Schedule",
        method: () => handleChooseSchedule("copy"), //handleCopySchedule,
        icon: null,
        visible: GuideEditMode && ScheduleNames.length > 1 && advancedMode,
        info: "Add all events from this schedule to another",
      },
      {
        label: "Copy Events from Schedules",
        method: () => handleChooseSchedule("copyFrom"), //handleCopySchedule,
        icon: null,
        visible: GuideEditMode && ScheduleNames.length > 1 && advancedMode,
        info: "Add all events from other schedules to this one",
      },
      {
        label: "Rename Schedule",
        method: handleRenameSchedule,
        icon: null,
        visible: GuideEditMode && advancedMode,
        info: "Rename the current schedule",
      },
      {
        label: "Recalculate Schedule",
        method: recalculateSchedule,
        icon: null,
        visible: GuideEditMode,
        info: "Recalculate event times based on place duration and travel distance, with an option to reorder events by location first.",
        videoKey: "recalculate-schedule",
      },
      {
        label: "Bulk Add Events",
        method: handleBulkAddEvents,
        icon: null,
        visible: GuideEditMode && advancedMode,
        info: "Add multiple events at once by pasting text, one event per line in the format 'subject;start_date_time;end_date_time;place_1|place_2|place_n' (places optional), or as a JSON array of objects with subject, start_date_time, end_date_time and optional places fields.",
      },
      {
        label: "Show Places in Map",
        method: () => {
          const allPlaces = window.guide_obj.getAllScheduledPlaces(ScheduleName);
          if (allPlaces.length === 0) return;
          dispatch(slice1Actions.ClearAllFilters());
          dispatch(slice1Actions.centerMapToPlaces({ value: allPlaces }));
          if (MobileMode) dispatch(slice1Actions.setCurrentAppScreen({ value: "Map" }));
          else window.location.href = "#map-start";
          setMenuModalShow(false);
        },
        icon: null,
        visible: true,
        info: "Show all places associated with events in this schedule on the map.",
      },
      {
        label: "Filter by Places in Schedule",
        method: () => { filterBySchedule(ScheduleName); setMenuModalShow(false); },
        icon: null,
        visible: true,
        info: "Filter the guide to show only places in this schedule.",
      },
      // {
      //   label: "Delete Schedule",
      //   method: () => handleChooseSchedule("delete"),
      //   icon: null,
      //   visible: GuideEditMode,
      //   info: "Delete the current schedule and all its events.",
      // },
    ];
    let menuList = buildMenuList(advancedMode);
    if (!advancedMode) {
      const hiddenCount = buildMenuList(true).filter((i) => i.visible).length - menuList.filter((i) => i.visible).length;
      if (hiddenCount > 0) {
        menuList = [
          ...menuList,
          {
            label: `${hiddenCount} more option${hiddenCount === 1 ? "" : "s"} in Advanced Mode`,
            method: () => {
              window.dispatchEvent(new CustomEvent("toggleAdvancedMode"));
              setTimeout(() => { if (scheduleMenuRef.current) scheduleMenuRef.current(); }, 350);
            },
            icon: null,
            visible: true,
            highlight: true,
            info: "Turn on Advanced Mode in Settings to see these options.",
          },
        ];
      }
    }

    //({ value: _MenuModalArgs }));
    setMenuModalList(menuList);
    setMenuModalHeading("Schedule Menu");
    setMenuModalImage(<FontAwesomeIcon icon={solid("user")} />);
    setMenuModalPlace(null);
    setMenuModalShow(true);
  };

  // The cover the itinerary would use with no override: the guide's own real
  // image, else the first place with a real photo (see comments inside).
  const getAutoCover = () => {
    const ILLUSTRATED_PLACEHOLDER = "https://andiamotravelapp.com/Images/App/IllustratedImage.jpg";
    // Also rejects a live Google Places (New) Photo Media URL — see
    // isBadCoverUrl below for why. Fixed 2026-08-30.
    const GOOGLE_PLACES_PHOTO_PATTERN = /places\.googleapis\.com\/v1\/.*\/media/i;
    const hasRealPhoto = (p) =>
      (p.Photo && p.Photo !== ILLUSTRATED_PLACEHOLDER && !GOOGLE_PLACES_PHOTO_PATTERN.test(p.Photo)) ||
      (p.Photo_m && p.Photo_m !== ILLUSTRATED_PLACEHOLDER && !GOOGLE_PLACES_PHOTO_PATTERN.test(p.Photo_m));
    // Preference order among places that have a real photo: Must See, then
    // Favorite, then the first place in the schedule being copied, then any
    // (was simply the first place in the list, often an arbitrary one).
    const withPhoto = window.guide_obj.places.placesList.filter((p) => p && !p.Hidden && hasRealPhoto(p));
    let coverPlace = withPhoto.find((p) => p.MustSee) || withPhoto.find((p) => p.Favorite);
    if (!coverPlace) {
      try {
        const events = [...(window.guide_obj.schedule.getEventsFromSchedule(ScheduleName) || [])].sort(
          (a, b) => (a.Start > b.Start ? 1 : a.Start < b.Start ? -1 : 0)
        );
        for (const ev of events) {
          coverPlace = (ev.get_places(window.guide_obj.places) || []).find((p) => p && withPhoto.includes(p));
          if (coverPlace) break;
        }
      } catch (e) {
        /* fall through to the generic pick */
      }
    }
    if (!coverPlace) coverPlace = withPhoto[0] || window.guide_obj.places.placesList.find(hasRealPhoto);
    // attributes.image_m being non-empty isn't enough on its own — it can
    // be sitting on the generic placeholder itself, which should still
    // fall through to a real coverPlace photo rather than being treated
    // as the user's chosen cover. Matches BuildMyTripWizard.js/TripAI.js's
    // identical "real, not just non-empty" check. Fixed 2026-08-30.
    // attributes.image_m being non-empty and not the placeholder isn't
    // enough on its own either — a stale, pre-fix cached copy of a guide
    // getting saved again can bring back a live Google Places (New)
    // Photo Media URL even after it was already remediated in Firestore.
    // Reject that pattern too, not just the placeholder. Fixed 2026-08-30.
    const isBadCoverUrl = (url) =>
      !url || url === ILLUSTRATED_PLACEHOLDER || /places\.googleapis\.com\/v1\/.*\/media/i.test(url);
    // .image, not .image_m, is the field every current guide-image flow
    // actually writes (GuideEditModal.js's save handler, BuildMyTripWizard.js,
    // TripAI.js, KMLInput.js — none of them touch .image_m). Preferring
    // .image_m here meant a guide's cover photo never picked up a change
    // made via "Edit Guide" — the itinerary kept showing whatever old photo
    // .image_m last held. .image_m kept as a fallback for older guides that
    // might only have it set, not because anything still writes it going
    // forward. Fixed 2026-09-05.
    const guideCustomCover = !isBadCoverUrl(window.guide_obj.attributes.image)
      ? window.guide_obj.attributes.image
      : !isBadCoverUrl(window.guide_obj.attributes.image_m)
      ? window.guide_obj.attributes.image_m
      : null;
    return guideCustomCover || coverPlace?.Photo_m || coverPlace?.Photo || null;
  };

  const doItinerary = () => {
    const settings = { ...ItinSettings, place_menu: false };
    const htmlString = window.guide_obj.createHTMLItinerary(ScheduleName, settings);
    setShowItinSettings(false);
    if (ItinAction === "copy") {
      // Same cover-image layout TripAI.js/BuildMyTripWizard.js use for their
      // generated Home document — this path never had one. Prefers the
      // guide's own designated cover photo (attributes.image_m), but many
      // guides (manually built, KML-imported, etc.) never get one set at
      // all — falls back to the first place with a real photo, same as
      // BuildMyTripWizard's own coverPlace search, rather than silently
      // showing nothing. Fixed 2026-08-29 — see memory:
      // project_cost_revenue_viability.
      const coverImageM =
        CoverMode === "none" ? null : CoverMode === "custom" && CoverCustomUrl ? CoverCustomUrl : getAutoCover();
      // Remember the choice: "no cover" in the guide's itinerary settings, a
      // picked photo as the guide's info image.
      if (CoverMode === "custom" && CoverCustomUrl) {
        window.guide_obj.attributes.image = CoverCustomUrl;
        window.guide_obj.attributes.image_m = CoverCustomUrl;
      }
      const wantsCover = CoverMode !== "none";
      if ((GuideSettings.itinerary?.cover !== false) !== wantsCover) {
        dispatch(
          slice1Actions.setGuideSettings({
            value: { ...GuideSettings, itinerary: { ...GuideSettings.itinerary, cover: wantsCover } },
          })
        );
      }
      // coverImageM can be a raw "gdrive:FILEID" sentinel (how the guide edit
      // dialog stores a Drive-picked cover photo) rather than a displayable
      // URL — run it through the same conversion every other Drive-photo
      // display path uses, or it renders as a broken image icon.
      const coverImageUrl = coverImageM ? Common.getImageURL(coverImageM, null, true) : null;
      const coverImg = coverImageUrl
        ? Common.coverImageHTML(coverImageUrl)
        : "";
      const fullDocument = `${coverImg}${htmlString}`;
      window.guide_obj.document = fullDocument;
      // Was dispatching the pre-cover-image htmlString here — the actually
      // DISPLAYED content is state.homeScreen (set by setHTMLToSHow, read
      // via useSelector in Home.js), not window.guide_obj.document read
      // directly, so the cover image was set on the guide but never shown.
      // Fixed 2026-08-29 — see memory: project_cost_revenue_viability.
      // The copied page IS the guide's home page now, not a sub-page pushed
      // on top of it — setHTMLToSHow pushed it onto the page history, which
      // made the name bar (title, Edit, format toggle) hide itself as if a
      // sub-page were showing. Reset the history the way the HTML editor's
      // own save does.
      dispatch(slice1Actions.clearHTMLStack());
      dispatch(slice1Actions.setHomeScreen({ value: fullDocument }));
      var homeDiv = document.getElementById("home-content-start");
      if (MobileMode) dispatch(slice1Actions.setCurrentAppScreen({ value: "Home" }));
      else if (homeDiv !== null) homeDiv.scrollIntoView();
    } else {
      dispatch(slice1Actions.setHTMLTitle({ value: "Itinerary" }));
      dispatch(slice1Actions.setHTMLToSHow({ value: htmlString }));
      dispatch(slice1Actions.setShowHTMLReader({ value: true }));
      window.location.href = "#home-start";
      var homeDiv2 = document.getElementById("home-content-start");
      if (MobileMode) dispatch(slice1Actions.setCurrentAppScreen({ value: "Home" }));
      else if (homeDiv2) homeDiv2.scrollIntoView();
    }
  };

  const handleChooseSchedule = (action) => {
    setScheduleAction(action);
    let items = ScheduleNames;
    if (action === "select" || action === "copyFrom" || action === "copy") {
      items = ScheduleNames.filter((x) => x.label !== ScheduleName);
    }
    setMultiselectItems(items);
    // Only "select" has a real "current selection" to show a checkmark
    // for — "delete"/"copy"/"copyFrom" are one-shot pick-a-target actions
    // with no lasting selection, so pre-checking the active schedule there
    // was just a meaningless leftover checkmark (e.g. showing up in the
    // "Delete Schedule" list next to the schedule you're not deleting).
    setMultiselectSelectedItems(action === "select" ? ScheduleName : []);
    setMultiselectMode(action === "copyFrom" ? "multi" : "uni");
    setMultiselectTitle(`Select Itinerary`);
    setShowMultiselect(true);
  };

  const chooseScheduleCallBack = (schedules) => {
    if (schedules.length === 0) return;
    if (ScheduleAction === "copyFrom") {
      for (let i = 0; i < schedules.length; i++) {
        if (ScheduleName === schedules[i].label) continue;
        window.guide_obj.schedule.copySchedule(schedules[i].label, ScheduleName);
      }
      dispatch(slice1Actions.setGuide({ guide: null }));
    } else if (ScheduleAction === "select") {
      if (schedules.length > 0) {
        const newScheduleName = schedules[0].label;
        // Choosing a schedule here should just switch the Schedule screen to
        // show it — filterBySchedule + setScheduleName already do that.
        // Also calling handleShowItinerary navigated away to the Itinerary/
        // Home screen instead, which is misleading: the user asked to
        // "choose a schedule to display", not to view its itinerary.
        // Found 2026-09-27.
        dispatch(slice1Actions.setScheduleName({ value: newScheduleName }));
        filterBySchedule(newScheduleName);
        // Builds a fresh auto-generated itinerary (with cover image —
        // createHTMLItinerary has no cover-image logic of its own, every
        // caller has to prepend one, see HomeHeader.js's updateHomePage/
        // doItinerary, BuildMyTripWizard.js) for the given schedule. Only
        // ever called for a non-"Main" schedule (Main always shows the real
        // saved document instead, see below), so a cover image here always
        // renders onto a single scrolling schedule-specific page, never the
        // top-level Mosaic grid — no need to skip it the way reducer.js's
        // resetHomeScreen has to for its own "Main" case.
        const buildItineraryPreview = (name) => {
          const htmlString = window.guide_obj.createHTMLItinerary(name, GuideSettings.itinerary);
          const ILLUSTRATED_PLACEHOLDER = "https://andiamotravelapp.com/Images/App/IllustratedImage.jpg";
          const GOOGLE_PLACES_PHOTO_PATTERN = /places\.googleapis\.com\/v1\/.*\/media/i;
          const isBadCoverUrl = (url) => !url || url === ILLUSTRATED_PLACEHOLDER || GOOGLE_PLACES_PHOTO_PATTERN.test(url);
          const hasRealPhoto = (p) => (p.Photo && !isBadCoverUrl(p.Photo)) || (p.Photo_m && !isBadCoverUrl(p.Photo_m));
          const guideCustomCover = !isBadCoverUrl(window.guide_obj.attributes.image_m) ? window.guide_obj.attributes.image_m : null;
          const coverPlace = guideCustomCover ? null : (window.guide_obj.places.placesList || []).find(hasRealPhoto);
          const coverImageM = guideCustomCover || coverPlace?.Photo_m || coverPlace?.Photo;
          const coverImg = coverImageM && !isBadCoverUrl(coverImageM) ? Common.coverImageHTML(Common.getImageURL(coverImageM, null, true)) : "";
          return `${coverImg}${htmlString}`;
        };
        // Displays the given HTML as the Itinerary view without navigating
        // anywhere — setHTMLToSHow writes into state.homeScreen (what's
        // shown), not window.guide_obj.document (the user's actual editable
        // content); those are deliberately separate, same as Map/Places
        // already showing only the selected schedule's content live without
        // touching anything persisted.
        const displayItinerary = (html) => {
          dispatch(slice1Actions.setHTMLTitle({ value: "Itinerary" }));
          // clearHTMLStack first — setHTMLToSHow PUSHES onto HTMLStack
          // rather than replacing it (same as GuideNameBar.js's own
          // HTMLEditCallback does before its own setHomeScreen). Without
          // this, HTMLStack.length becomes 2, and GuideNameBar.js's
          // isSubPage check (HTMLStack.length > 1) hides the guide name/
          // Edit button, treating this as if a sub-page were being shown on
          // top of Home. Found 2026-09-27.
          dispatch(slice1Actions.clearHTMLStack());
          dispatch(slice1Actions.setHTMLToSHow({ value: html }));
          dispatch(slice1Actions.setGuide({ guide: null, fitToBounds: true }));
        };
        if (newScheduleName === "Main") {
          // "Main" is special: its content isn't a computed preview, it IS
          // the guide's real, persisted document (window.guide_obj.document)
          // — possibly hand-customized by the user via the HTML editor.
          // Every OTHER schedule has no persisted document of its own, so
          // those always get a fresh computed preview (see below) — but
          // doing that for "Main" too silently replaced the user's actual
          // customized itinerary in the DISPLAY with an auto-generated one
          // the moment they navigated back to Main (still safe in
          // window.guide_obj.document itself the whole time — "Edit
          // Itinerary" reads that directly, unaffected). Always show the
          // real saved document for Main, no prompt — the user must
          // deliberately overwrite it via "Copy to Trip Itinerary" if they
          // want it regenerated; choosing Main from Choose Schedule should
          // never do that on their behalf, even as an offered option.
          // Found 2026-09-27, revised 2026-09-27 (dropped the "Regenerate"
          // choice this same day's earlier commit f87b1b9 had added).
          dispatch(slice1Actions.resetHomeScreen({ value: null }));
          dispatch(slice1Actions.setGuide({ guide: null, fitToBounds: true }));
          return;
        }
        displayItinerary(buildItineraryPreview(newScheduleName));
      }
    } else if (ScheduleAction === "delete") {
      handleDeleteSchedule(schedules[0].label);
    } else if (ScheduleAction === "copy") {
      if (ScheduleName === schedules[0].label) {
        MyAlert("You cannot copy to the same schedule.");
        return;
      }
      window.guide_obj.schedule.copySchedule(ScheduleName, schedules[0].label);
      dispatch(slice1Actions.setScheduleName({ value: schedules[0].label }));
      dispatch(slice1Actions.setGuide({ guide: null }));
    }
  };

  const handleDeleteSchedule = (schedule) => {
    myAlert("Confirmation", `Delete all events in ${schedule}?`, [
      { Title: "OK", Method: () => _deleteSchedule(schedule) },
      { Title: "CANCEL", Method: null },
    ]);
  };

  const _deleteSchedule = (schedule) => {
    window.guide_obj.schedule.deleteAllEvents(schedule);
    // Clear schedule field on any group associated with this schedule
    for (const grp of window.guide_obj.groups) {
      if (grp.schedule === schedule) {
        window.guide_obj.modifyGroup(grp, { ...grp, schedule: "" });
      }
    }
    dispatch(slice1Actions.setScheduleName({ value: "Main" }));
    dispatch(slice1Actions.setGuide({ guide: null }));
    if(GuideFormat === "Photo Mosaic")
    {
        const html = window.guide_obj.createHTMLItinerary("Main", GuideSettings.itinerary);
        //////5/25///
        //window.guide_obj.document = html;
        ///////
        dispatch(slice1Actions.clearHTMLStack());
        //dispatch(slice1Actions.popHTMLStack());
        dispatch(slice1Actions.setHomeScreen({ value: html }));
        
        // dispatch(slice1Actions.setHTMLTitle({ value: "Itinerary" }));
        // dispatch(slice1Actions.setHTMLToSHow({ value: htmlString }));
        // dispatch(slice1Actions.setShowHTMLReader({ value: true }));
        // dispatch(slice1Actions.resetHTMLScreen());
    }
  };

  const handleChangeStartDay = () => {
    setMode("change_start_date");
    setMoveEventsShow(true);
  };

  const CopyScheduleCallback = (schedule) => {
    window.guide_obj.schedule.deleteAllEvents(schedule);
    dispatch(slice1Actions.setScheduleName({ value: "Main" }));
    dispatch(slice1Actions.setGuide({ guide: null }));
  };

  const handleAddSchedule = () => {
    setPromptModalArea(false);
    setPromptModalShow(true);
    setPromptModalTitle("Add");
    setPromptModalMessage("Add Schedule:");
    setPromptModalButtons([
      { Title: "OK", Method: AddScheduleCallback },
      { Title: "CANCEL", Method: null },
    ]);
    setPromptModalInputs([{ name: "Group Name", value: ScheduleName + "2" }]);
  };

  const AddScheduleCallback = (sched_name) => {
    console.log("sched_name", sched_name);
    if (sched_name[0].value === "Main") {
      MyAlert("Cannot create another Main menu. Choose a different name.");
      return;
    }
    let new_event = new Appointment();
    new_event.Subject = "New Event";
    new_event.Start = DateTime.now().toISO({ zone: "utc" });
    new_event.End = DateTime.now().toISO({ zone: "utc" });
    new_event.Body = "";
    new_event.Itinerary = sched_name[0].value;
    window.guide_obj.schedule.addEvent(new_event);
    dispatch(slice1Actions.setScheduleName({ value: sched_name[0].value }));
    dispatch(slice1Actions.setGuide({ guide: null }));
  };

  const handleRenameSchedule = () => {
    if (ScheduleName === "Main") {
      MyAlert("You cannot rename the 'Main' schedule, but you can create a copy.");
      return;
    }
    setPromptModalArea(false);
    setPromptModalShow(true);
    setPromptModalTitle("Rename");
    setPromptModalMessage("Rename Schedule");
    setPromptModalButtons([
      { Title: "OK", Method: RenameScheduleCallback },
      { Title: "CANCEL", Method: null },
    ]);
    setPromptModalInputs([{ name: "Group Name", value: ScheduleName }]);
  };

  const handleBulkAddEvents = () => {
    setPromptModalArea(true);
    setPromptModalShow(true);
    setPromptModalTitle("Bulk Add Events");
    setPromptModalMessage(
      "Paste events below, one per line (places optional):\n\nsubject;start;end;place_1|place_2\n\nExample:\nBreakfast at hotel;2026-06-10 08:00;2026-06-10 09:00;Grand Hotel\nLunch;2026-06-10 12:00;2026-06-10 13:00\nCity tour;2026-06-10 14:00;2026-06-10 17:00;Tokyo Tower|Shibuya Crossing\n\nDates: YYYY-MM-DD HH:MM (24-hour). Places are optional."
    );
    setPromptModalButtons([
      { Title: "OK", Method: BulkAddEventsCallback },
      { Title: "CANCEL", Method: null },
    ]);
    setPromptModalInputs([{ name: "Bulk Events", value: "" }]);
  };

  const resolvePlaceIdByName = (name) => {
    const trimmedName = name.trim().toLowerCase();
    const place = window.guide_obj.places.placesList.find(
      (x) => x.Name && x.Name.trim().toLowerCase() === trimmedName
    );
    return place ? place.ID : null;
  };

  const parseBulkEventDate = (dateStr) => {
    const trimmed = (dateStr || "").trim();
    // ISO with T separator
    let dt = DateTime.fromISO(trimmed, { zone: "utc" });
    // ISO with space separator (e.g. "2024-03-15 10:00")
    if (!dt.isValid) dt = DateTime.fromISO(trimmed.replace(" ", "T"), { zone: "utc" });
    // Common explicit formats — all forced to UTC, no local-timezone shift
    if (!dt.isValid) dt = DateTime.fromFormat(trimmed, "yyyy-MM-dd HH:mm", { zone: "utc" });
    if (!dt.isValid) dt = DateTime.fromFormat(trimmed, "yyyy-MM-dd HH:mm:ss", { zone: "utc" });
    if (!dt.isValid) dt = DateTime.fromFormat(trimmed, "M/d/yyyy H:mm", { zone: "utc" });
    if (!dt.isValid) dt = DateTime.fromFormat(trimmed, "M/d/yyyy H:mm:ss", { zone: "utc" });
    return dt.isValid ? dt.toISO({ zone: "utc" }) : null;
  };

  const parseBulkEventsText = (text) => {
    const trimmedText = text.trim();
    if (trimmedText === "") {
      return { errors: ["No text was entered."], entries: [] };
    }

    const errors = [];
    const entries = [];

    if (trimmedText.startsWith("[")) {
      let parsed;
      try {
        parsed = JSON.parse(trimmedText);
      } catch (e) {
        return { errors: [`Invalid JSON: ${e.message}`], entries: [] };
      }
      if (!Array.isArray(parsed)) {
        return { errors: ["Invalid JSON: expected an array of events."], entries: [] };
      }
      parsed.forEach((item, index) => {
        const entryLabel = `Entry ${index + 1}`;
        if (!item || typeof item !== "object") {
          errors.push(`${entryLabel}: is not a valid object.`);
          return;
        }
        const { subject, start_date_time, end_date_time, places } = item;
        if (!subject || typeof subject !== "string") {
          errors.push(`${entryLabel}: missing or invalid 'subject'.`);
          return;
        }
        if (!start_date_time) {
          errors.push(`${entryLabel}: missing 'start_date_time'.`);
          return;
        }
        if (!end_date_time) {
          errors.push(`${entryLabel}: missing 'end_date_time'.`);
          return;
        }
        const placeList = Array.isArray(places) ? places : [];
        entries.push({ label: entryLabel, subject, start_date_time, end_date_time, placeNames: placeList });
      });
    } else {
      const lines = trimmedText.split("\n").map((l) => l.trim()).filter((l) => l !== "");
      lines.forEach((line, index) => {
        const entryLabel = `Line ${index + 1}`;
        const parts = line.split(";");
        if (parts.length < 3) {
          errors.push(
            `${entryLabel}: expected format 'subject;start_date_time;end_date_time' but got "${line}".`
          );
          return;
        }
        const [subject, start_date_time, end_date_time, placesPart] = parts;
        if (subject.trim() === "") {
          errors.push(`${entryLabel}: missing subject.`);
          return;
        }
        const placeNames = placesPart ? placesPart.split("|").map((p) => p.trim()).filter((p) => p !== "") : [];
        entries.push({
          label: entryLabel,
          subject: subject.trim(),
          start_date_time: start_date_time.trim(),
          end_date_time: end_date_time.trim(),
          placeNames,
        });
      });
    }

    if (errors.length > 0) return { errors, entries: [] };

    const eventsToAdd = [];
    entries.forEach((entry) => {
      const startISO = parseBulkEventDate(entry.start_date_time);
      if (startISO === null) {
        errors.push(`${entry.label}: invalid start date/time "${entry.start_date_time}".`);
        return;
      }
      const endISO = parseBulkEventDate(entry.end_date_time);
      if (endISO === null) {
        errors.push(`${entry.label}: invalid end date/time "${entry.end_date_time}".`);
        return;
      }
      const placeIds = [];
      for (const placeName of entry.placeNames) {
        const placeId = resolvePlaceIdByName(placeName);
        if (placeId === null) {
          errors.push(`${entry.label}: place "${placeName}" was not found.`);
          continue;
        }
        placeIds.push(placeId);
      }
      eventsToAdd.push({
        Subject: entry.subject,
        Start: startISO,
        End: endISO,
        Places: placeIds.join(","),
        Itinerary: ScheduleName,
      });
    });

    if (errors.length > 0) return { errors, entries: [] };
    return { errors: [], entries: eventsToAdd };
  };

  const BulkAddEventsCallback = (inputs) => {
    const text = inputs[0].value || "";
    const { errors, entries } = parseBulkEventsText(text);
    if (errors.length > 0) {
      myAlert("Syntax Error", errors.join("\n"), [{ Title: "OK", Method: null }]);
      return;
    }
    entries.forEach((event) => window.guide_obj.schedule.addEvent(event));
    dispatch(slice1Actions.setGuide({ guide: null }));
    myAlert("Success", `Added ${entries.length} event${entries.length === 1 ? "" : "s"}.`, [
      { Title: "OK", Method: null },
    ]);
  };

  const RenameScheduleCallback = (sched_name) => {
    console.log("sched_name", sched_name);
    const newScheduleName = sched_name[0].value;
    window.guide_obj.schedule.renameSchedule(ScheduleName, newScheduleName, window.guide_obj);
    // Update any group whose schedule field matches the old name
    for (const grp of window.guide_obj.groups) {
      if (grp.schedule === ScheduleName) {
        window.guide_obj.modifyGroup(grp, { ...grp, schedule: newScheduleName, mosaic: true });
      }
    }
    dispatch(slice1Actions.setScheduleName({ value: newScheduleName }));
    dispatch(slice1Actions.setGuide({ guide: null }));
  };

  const MoveEventsCallback = () => {
    dispatch(slice1Actions.setGuide({ guide: null }));
  };

  const MyAlert = (message) => {
    setAlertModalTitle("Message");
    setAlertModalMessage(message);
    setAlertModalButtons([{ Title: "OK", Method: null }]);
    setAlertModalShow(true);
  };

  const myAlert = (title, message, buttons) => {
    setAlertModalTitle(title);
    setAlertModalMessage(message);
    setAlertModalButtons(buttons);
    setAlertModalShow(true);
  };

  const EventEditCallback = () => {
    dispatch(slice1Actions.resetHomeScreen({ value: null }));
    dispatch(slice1Actions.setGuide({ guide: null }));
  };

  // const showSchedules = (e) => {
  //   e.stopPropagation();
  //   dispatch(slice1Actions.setMultiselectCallback({ value: chooseScheduleCallBack2 }));
  //   dispatch(slice1Actions.setMultiselectItems({ value: ScheduleNames }));
  //   dispatch(slice1Actions.setMultiselectSelectedItems({ value: ScheduleName }));
  //   dispatch(slice1Actions.setMultiselectMode({ value: "uni" }));
  //   dispatch(slice1Actions.setMultiselectSearchText({ value: "" }));
  //   dispatch(slice1Actions.setMultiselectTitle({ value: "Select Schedule" }));
  //   dispatch(slice1Actions.setShowMultiselect({ value: true }));
  // };

  // const chooseScheduleCallBack2 = (schedules) => {
  //   if (schedules.length > 0) {
  //     dispatch(slice1Actions.setScheduleName({ value: schedules[0].label }));
  //     dispatch(slice1Actions.setGuide({ guide: null }));
  //   }
  // };

  const startPlayingItinerary = () => {
    let events = window.guide_obj.schedule.getEventsFromSchedule(ScheduleName);
    if (events.length === 0) return;
    // Clear any previous interval before starting a new one — otherwise
    // pressing Play again while a stale one was still silently running
    // (see playTimerRef's own comment) stacks a second interval on top
    // instead of replacing it.
    clearInterval(playTimerRef.current);
    setPlayState("Playing");
    playTimerRef.current = setInterval(playEvent, 3000);
    playEvent();
  };

  const stopPlayingItinerary = () => {
    dispatch(slice1Actions.setPlayEventsIndex({ value: 0 }));
    setPlayState("Stopped");
    clearInterval(playTimerRef.current);
    unHighlightAll();
  };

  const unHighlightAll = () => {
    const places = window.guide_obj.places.placesList;
    for (let j = 0; j < places.length; j++) {
      var placeElement = document.getElementById(`PlaceCard${places[j].ID}`);
      if (placeElement !== null) {
        placeElement.style.backgroundColor = "#ffffff";
      }
      let eventElement = document.getElementById(`eventID${places[j].ID}`);
      if (eventElement !== null) {
        eventElement.style.backgroundColor = "#ffffff";
      }
    }
    dispatch(slice1Actions.setHighlightedPlaces({ value: [] }));
  };

  const pausePlayingItinerary = () => {
    setPlayState("Paused");
    clearInterval(playTimerRef.current);
  };

  const playEvent = () => {
    let events = window.guide_obj.schedule.getEventsFromSchedule(ScheduleName);
    // if (events.length === 0) {
    //   stopPlayingItinerary();
    //   return;
    // }
    // if (events.length !== playEvents.length) {
    //   setPlayEvents(events);
    //   setPlayIndex(0);
    // }
    // unhighlight last event places
    const currentIndex = PlayEventsIndexRef.current;
    let last_playIndex = currentIndex === 0 ? events.length - 1 : currentIndex - 1;
    if (typeof events[last_playIndex] === "undefined") {
      stopPlayingItinerary();
      return;
    }
    let places = events[last_playIndex].Places;
    if (!Array.isArray(places)) places = places.split(",");
    dispatch(slice1Actions.setHighlightedPlaces({ value: [] }));
    if (places.length !== 0) highlightPlace(places[0], false);

    if (currentIndex >= events.length) {
      //console.log("events.length !== playEvents.length");
      stopPlayingItinerary();
      return;
    }
    // highlight current event places
    places = events[currentIndex].Places;
    if (!Array.isArray(places)) places = places.split(",");
    dispatch(slice1Actions.setHighlightedPlaces({ value: places }));
    if (places.length !== 0) highlightPlace(places[0], true);

    // set next event index
    //let next_playIndex = currentIndex >= events.length - 1 ? 0 : currentIndex + 1;
    PlayEventsIndexRef.current = currentIndex + 1;
    dispatch(slice1Actions.setPlayEventsIndex({ value: currentIndex + 1 }));
  };

  const recalculateSchedule = () => {
    setRecalcDialogShow(true);
  };

  // "Flag after the fact": the recalculation algorithm itself is never
  // modified to reschedule around closures. This just checks the results
  // afterward and summarizes any conflicts — the per-event warning badge in
  // SchedulePanel.js picks them up automatically once state refreshes.
  const reportOpeningHoursConflicts = (itinerary) => {
    const events = window.guide_obj.schedule.events.filter((e) => {
      const eventItinerary = typeof e.Itinerary === "undefined" ? "Main" : e.Itinerary.replace(/%20/g, " ");
      return eventItinerary === itinerary;
    });
    const conflictCount = events.filter((e) => {
      const status = Place.getOpeningHoursConflict(e, window.guide_obj.places).status;
      return status === "closed" || status === "closes_during";
    }).length;
    if (conflictCount > 0) {
      myAlert(
        `${conflictCount} event${conflictCount === 1 ? "" : "s"} outside opening hours`,
        "Some events were scheduled at a time when the place appears to be closed. Look for the warning icon in the schedule to review them.",
        [{ Title: "OK", Method: null }]
      );
    }
  };

  // See SchedulePanel.js's matching reportIdleTime comment — recalculate
  // only re-times existing events, never adds/removes places, so a pace
  // change toward Packed can leave real unused time at day-end with nothing
  // to fill it. Found 2026-09-30.
  const IDLE_TIME_THRESHOLD_MINUTES = 60;
  const reportIdleTime = (itinerary, dayEndHour) => {
    const events = window.guide_obj.schedule.events.filter((e) => {
      const eventItinerary = typeof e.Itinerary === "undefined" ? "Main" : e.Itinerary.replace(/%20/g, " ");
      return eventItinerary === itinerary;
    });
    if (events.length === 0) return;
    const lastEndByDay = new Map();
    events.forEach((e) => {
      const dayKey = DateTime.fromISO(e.Start, { zone: "utc" }).toISODate();
      const end = DateTime.fromISO(e.End, { zone: "utc" });
      if (!lastEndByDay.has(dayKey) || end > lastEndByDay.get(dayKey)) lastEndByDay.set(dayKey, end);
    });
    let idleDayCount = 0;
    let totalIdleMinutes = 0;
    let biggestGapKey = null;
    let biggestGapMinutes = -1;
    for (const [dayKey, lastEnd] of lastEndByDay) {
      const dayEndTarget = DateTime.fromISO(dayKey + "T00:00:00.000Z", { zone: "utc" }).plus({ hours: dayEndHour });
      const idleMinutes = dayEndTarget.diff(lastEnd, "minutes").minutes;
      if (idleMinutes >= IDLE_TIME_THRESHOLD_MINUTES) {
        idleDayCount++;
        totalIdleMinutes += idleMinutes;
        if (idleMinutes > biggestGapMinutes) {
          biggestGapMinutes = idleMinutes;
          biggestGapKey = dayKey;
        }
      }
    }
    if (idleDayCount === 0) return;
    myAlert(
      "Free time in your schedule",
      `${idleDayCount} day${idleDayCount === 1 ? "" : "s"} now ${idleDayCount === 1 ? "has" : "have"} about ${Common.formatTravelDuration(Math.round(totalIdleMinutes))} of unused time before your day-end time.`,
      [
        { Title: "Not now", Method: null },
        { Title: "Find places", Method: () => openFillIdleTime(itinerary, biggestGapKey, dayEndHour) },
      ]
    );
  };

  const [fillIdleShow, setFillIdleShow] = useState(false);
  const [fillIdleDayLabel, setFillIdleDayLabel] = useState("");
  const [fillIdleRemainingMinutes, setFillIdleRemainingMinutes] = useState(0);
  const [fillIdleCandidates, setFillIdleCandidates] = useState([]);
  const fillIdleContextRef = useRef(null);

  // Port of SchedulePanel.js's matching functions — see its comments.
  const refreshFillIdleCandidates = () => {
    const ctx = fillIdleContextRef.current;
    if (!ctx) return;
    const remainingMinutes = ctx.windowEnd.diff(ctx.windowStart, "minutes").minutes;
    setFillIdleRemainingMinutes(remainingMinutes);
    if (remainingMinutes < IDLE_TIME_THRESHOLD_MINUTES / 2) {
      setFillIdleCandidates([]);
      return;
    }
    const candidates = Schedule.findFillCandidates(ctx.anchorPlace, ctx.windowStart, ctx.windowEnd, Schedule.eventsCountedAsUsed(ctx.itinerary), window.guide_obj.places);
    setFillIdleCandidates(candidates);
  };

  const openFillIdleTime = (itinerary, dayKey, dayEndHour) => {
    const dayEvents = window.guide_obj.schedule.events.filter((e) => {
      const eventItinerary = typeof e.Itinerary === "undefined" ? "Main" : e.Itinerary.replace(/%20/g, " ");
      return eventItinerary === itinerary && DateTime.fromISO(e.Start, { zone: "utc" }).toISODate() === dayKey;
    });
    if (dayEvents.length === 0) return;
    const sorted = [...dayEvents].sort((a, b) => DateTime.fromISO(b.End, { zone: "utc" }) - DateTime.fromISO(a.End, { zone: "utc" }));
    const lastEvent = sorted[0];
    const lastWithPlace = sorted.find((e) => (e.Places || "").trim() !== "");
    const anchorPlace = lastWithPlace
      ? window.guide_obj.places.getPlace((lastWithPlace.Places || "").split(",")[0].trim())
      : null;
    const windowStart = DateTime.fromISO(lastEvent.End, { zone: "utc" });
    const windowEnd = DateTime.fromISO(dayKey + "T00:00:00.000Z", { zone: "utc" }).plus({ hours: dayEndHour });
    fillIdleContextRef.current = { itinerary, dayKey, dayEndHour, windowStart, windowEnd, anchorPlace };
    setFillIdleDayLabel(DateTime.fromISO(dayKey, { zone: "utc" }).toFormat("ccc, MMM d"));
    refreshFillIdleCandidates();
    setFillIdleShow(true);
  };

  const closeFillIdleTime = () => {
    setFillIdleShow(false);
    fillIdleContextRef.current = null;
  };

  const handleAddFillPlace = (place) => {
    const ctx = fillIdleContextRef.current;
    if (!ctx) return;
    const rounding_to = user_info.event_time_rounding ?? 15;
    const maxAllowedDate = DateTime.fromISO(ctx.dayKey + "T00:00:00.000Z", { zone: "utc" }).plus({ days: 1 });
    const newEnd = window.guide_obj.schedule.addEventOpeningHoursAware(
      place, ctx.itinerary, ctx.windowStart, ctx.anchorPlace, rounding_to, false,
      GuideSettings.schedule_day_start ?? 9, ctx.dayEndHour, window.guide_obj.places, maxAllowedDate, 1, null
    );
    if (!newEnd) {
      setFillIdleCandidates((prev) => prev.filter((p) => p.ID !== place.ID));
      return;
    }
    dispatch(slice1Actions.setGuide({ guide: null }));
    fillIdleContextRef.current = { ...ctx, windowStart: newEnd, anchorPlace: place };
    refreshFillIdleCandidates();
  };

  const runRecalculateSchedule = ({ startHour, endHour, usePlaceDuration, avoidClosed, geography, paceMultiplier }) => {
    window.guide_obj.schedule.recalculateSchedule(
      ScheduleName,
      user_info.event_time_rounding,
      user_info.default_duration,
      window.guide_obj.places,
      geography,
      startHour,
      endHour,
      usePlaceDuration,
      avoidClosed,
      null,
      paceMultiplier
    );
    dispatch(slice1Actions.setGuide({ guide: null }));
    reportOpeningHoursConflicts(ScheduleName);
    reportIdleTime(ScheduleName, endHour);
  };

  const highlightPlace = (placeID, enter) => {
    const place = window.guide_obj.places.getPlace(placeID);
    if (place === null) return;
    const placeElement = document.getElementById(`PlaceCard${placeID}`);
    const eventElement = document.getElementById(`eventID${placeID}`);
    if (enter === true) {
      if (eventElement !== null) {
        eventElement.scrollIntoView();
        eventElement.style.backgroundColor = "yellow";
      }
      if (placeElement !== null) {
        placeElement.scrollIntoView();
        placeElement.style.backgroundColor = "yellow";
      }
      let htmlString = PlaceMenu.handleShowPlaceAttributes(place.ID, SearchResultsPlacesList);
      htmlString = urlSchemeToFunctions(htmlString);
      dispatch(slice1Actions.setHTMLTitle({ value: "Place Details" }));
      dispatch(slice1Actions.setHTMLToSHow({ value: htmlString }));
      dispatch(slice1Actions.setShowHTMLReader({ value: true }));
      window.location.href = "#home-start";
      let homeDiv = document.getElementById("home-content-start");
      if (MobileMode) dispatch(slice1Actions.setCurrentAppScreen({ value: "Home" }));
      else if (homeDiv !== null) {
        dispatch(slice1Actions.centerMapToPlaces({ value: [place] }));
        homeDiv.scrollIntoView();
      }
    } else {
      dispatch(slice1Actions.setHighlightedPlaces({ value: [] }));
      if (placeElement !== null) {
        placeElement.style.backgroundColor = "#ffffff";
      }
      if (eventElement !== null) {
        eventElement.style.backgroundColor = "#ffffff";
      }
    }
  };

  if (GuideSettings.hide_schedule === true || HideSchedule === true) return null;
  return (
    <div>
      {/* Toolbar row */}
      <div className="sh-toolbar">
        {/* Only shown after a link/menu action (Home.js's schedulelink)
            jumped straight to Schedule in mobile mode, recording where it
            came from since CurrentAppScreen itself has no history — same
            pattern as PlacesHeader.js's back arrow for Map/Places. Pops one
            level of AppScreenStack per click, so a chain of jumps steps
            back through each one instead of losing the earlier hops.
            Found/fixed 2026-09-09 as a single value, extended to a real
            stack the same day. */}
        {MobileMode === true && CurrentAppScreen === "Schedule" && AppScreenStack.length > 0 && (
          <button
            className="sh-tool-btn"
            title="Back"
            onClick={() => {
              dispatch(slice1Actions.setCurrentAppScreen({ value: AppScreenStack[AppScreenStack.length - 1] }));
              dispatch(slice1Actions.popAppScreen());
            }}
          >
            <FontAwesomeIcon icon={solid("arrow-left")} />
          </button>
        )}
        <div className="sh-search">
          <input
            type="text"
            value={EventSearchText}
            placeholder="Search schedule"
            onChange={handleSearChanged}
          />
          {EventSearchText.length > 0 && (
            <button
              className="sh-clear-btn"
              onClick={() => {
                dispatch(slice1Actions.setEventSearchText({ value: "" }));
                dispatch(slice1Actions.setGuide({ guide: null }));
              }}
            >
              <FontAwesomeIcon icon={solid("xmark")} />
            </button>
          )}
        </div>
        {GuideEditMode && (
          <button className="sh-tool-btn" title="Add event" onClick={() => handleAddEventA()}>
            <FontAwesomeIcon icon={solid("plus")} />
          </button>
        )}
        <button className="sh-tool-btn" title="Schedule menu" onClick={() => scheduleMenu()}>
          <FontAwesomeIcon icon={solid("ellipsis")} />
        </button>
      </div>

      {/* Name + controls row */}
      <div className="sh-name-row">
        <button className="sh-name-pill" title="Schedule options">  
          <span className="sh-name-text">{ScheduleName}</span>
          {/* <FontAwesomeIcon icon={solid("chevron-down")} className="sh-name-chevron" /> */}
        </button>
        {/* {ScheduleNames.length > 1 && (
          <button className="sh-sm-btn" title="Schedule Menu" onClick={() => scheduleNameClickedMenu()}>
            <FontAwesomeIcon icon={solid("ellipsis")} />
          </button>
        )} */}
        {/* {ScheduleNames.length > 1 && (
          <button className="sh-sm-btn" title="Switch schedule" onClick={() => handleChooseSchedule("select")}>
            <FontAwesomeIcon icon={solid("calendar-alt")} />
          </button>
        )} */}
        {schedule.length > 0 && (
          <button
            className={`sh-dnd-toggle${ScheduleDndEnabled ? " sh-dnd-toggle--on" : ""}`}
            title={ScheduleDndEnabled ? "Turn off reorder" : "Turn on drag to reorder"}
            onClick={() => dispatch(slice1Actions.setScheduleDndEnabled({ value: !ScheduleDndEnabled }))}
          >
            <FontAwesomeIcon icon={solid("grip-vertical")} style={{ marginRight: 4 }} />
            {ScheduleDndEnabled ? "On" : "Off"}
          </button>
        )}
        <span className="sh-spacer" />
        {(() => {
          // Deliberately device-local, not DateTime.utc(): "today" needs to match
          // the traveler's actual current day. For someone physically at the
          // destination, the device's real timezone naturally tracks the
          // destination's local day — literal UTC would only coincidentally line
          // up and can be off by hours.
          const todayISO = DateTime.now().toISODate();
          const hasToday = schedule.some((s) => s.date?.toISODate?.() === todayISO);
          if (!hasToday) return null;
          return (
            <button
              className={`sh-today-btn${todayActive ? " sh-today-btn--on" : ""}`}
              title={todayActive ? "Exit today mode" : "Show today's itinerary and places"}
              onClick={() => {
                if (todayActive) {
                  // Deactivate: clear day filter and restore full guide
                  dispatch(slice1Actions.SetDatesFilter({ value: [] }));
                  dispatch(slice1Actions.setShowHiddenPlace({ value: [] }));
                  dispatch(slice1Actions.setGuide({ guide: null }));
                  const fullHtml = GuideFormat === "Photo Mosaic"
                    ? window.guide_obj.createHTMLItinerary("Main", GuideSettings.itinerary)
                    : window.guide_obj.document;
                  dispatch(slice1Actions.clearHTMLStack());
                  dispatch(slice1Actions.setHomeScreen({ value: fullHtml }));
                  dispatch(slice1Actions.setTodayMode({ value: false }));
                  return;
                }
                // 1. Scroll schedule to today
                const el = document.getElementById(`schedule-day-${todayISO}`);
                const container = document.getElementById("ScheduleDiv");
                if (el && container) {
                  container.scrollTo({ top: el.offsetTop - container.offsetTop, behavior: "smooth" });
                } else if (el) {
                  el.scrollIntoView({ behavior: "smooth", block: "start" });
                }
                // 2. Filter places by today (same as "Filter by this day")
                const todaySection = schedule.find((s) => s.date?.toISODate?.() === todayISO);
                const label = todaySection?.Title || todayISO;
                // Re-anchor the device-local calendar date to the UTC-bucketed
                // millis that getAllScheduledPlaces/stored events use — todayISO
                // picks the right *day*, but the actual bucket-matching value
                // still has to line up with how event dates are stored (UTC-as-typed).
                const dayTime = DateTime.fromISO(todayISO, { zone: "utc" }).toMillis();
                const allScheduledPlaces = window.guide_obj.getAllScheduledPlaces(ScheduleName, dayTime);
                const hiddenToShow = allScheduledPlaces.filter((p) => p.Hidden === true);
                dispatch(slice1Actions.setShowHiddenPlace({ value: hiddenToShow }));
                dispatch(slice1Actions.SetDatesFilter({ value: [{ label, value: dayTime }] }));
                dispatch(slice1Actions.setGuide({ guide: null, fitToBounds: true }));
                // 3. Generate today-only itinerary and navigate to it
                // createHTMLItinerary branches into the Photo Mosaic tile-grid
                // renderer whenever these 4 flags match — that branch has no
                // concept of filterDate and always shows every day, so force the
                // linear day-by-day path (which does respect filterDate) for the
                // Today view specifically, regardless of the guide's own format.
                const todayHtml = window.guide_obj.createHTMLItinerary(
                  ScheduleName,
                  { ...GuideSettings.itinerary, directions: true },
                  { ...user_info, showHiddenPlaces: false },
                  GuideSettings,
                  todayISO
                );
                dispatch(slice1Actions.clearHTMLStack());
                dispatch(slice1Actions.setHTMLTitle({ value: "Today" }));
                dispatch(slice1Actions.setHomeScreen({ value: todayHtml }));
                dispatch(slice1Actions.setCurrentAppScreen({ value: "Home" }));
                dispatch(slice1Actions.setTodayMode({ value: true }));
                window.location.href = "#home-start";
              }}
            >
              Today
            </button>
          );
        })()}
        {!MobileMode && schedule.length > 0 && (playState === "Stopped" || playState === "Paused") && (
          <button className="sh-sm-btn accent" title="Play itinerary" onClick={() => startPlayingItinerary()}>
            <FontAwesomeIcon icon={solid("play")} />
          </button>
        )}
        {!MobileMode && schedule.length > 0 && playState === "Playing" && (
          <button className="sh-sm-btn accent" title="Pause itinerary" onClick={() => pausePlayingItinerary()}>
            <FontAwesomeIcon icon={solid("pause")} />
          </button>
        )}
        {!MobileMode && schedule.length > 0 && (playState === "Playing" || playState === "Paused") && (
          <button className="sh-sm-btn" title="Stop itinerary" onClick={() => stopPlayingItinerary()}>
            <FontAwesomeIcon icon={solid("stop")} />
          </button>
        )}
      </div>

      <ScheduleModal show={scheduleModal} onHide={() => setScheduleModal(false)} />
      {MenuModalShow ? (
        <MenuModal
          id="MenuModal"
          show={MenuModalShow}
          onHide={() => setMenuModalShow(false)}
          menu_modal_list={MenuModalList}
          menu_modal_heading={MenuModalHeading}
          menu_model_image={MenuModalImage}
          menu_modal_place={MenuModalPlace}
        />
      ) : null}
      {ShowEventEdit ? (
        <EventEdit
          show={ShowEventEdit}
          onHide={() => setShowEventEdit(false)}
          event={null}
          mode={EventEditMode}
          place={null}
          where={EventEditWhere}
          schedule_name={ScheduleName}
          callback={() => EventEditCallback()}
        />
      ) : null}
      {MoveEventsShow ? (
        <MoveEvents
          show={MoveEventsShow}
          onHide={() => setMoveEventsShow(false)}
          ScheduleName={ScheduleName}
          ScheduleNames={ScheduleNames}
          mode={Mode}
          param_date={ParamDate}
          callback={MoveEventsCallback}
        />
      ) : null}
      {PromptModalShow ? (
        <PromptModal
          show={PromptModalShow}
          onHide={() => setPromptModalShow(false)}
          PromptModalTitle={PromptModalTitle}
          PromptModalMessage={PromptModalMessage}
          PromptModalButtons={PromptModalButtons}
          PromptModalInputs={PromptModalInputs}
          area={PromptModalArea}
        />
      ) : null}
      {RecalcDialogShow && (
        <RecalculateDialog
          show={RecalcDialogShow}
          onHide={() => setRecalcDialogShow(false)}
          onConfirm={runRecalculateSchedule}
          defaultStart={GuideSettings.schedule_day_start ?? 9}
          defaultEnd={GuideSettings.schedule_day_end ?? 20}
        />
      )}
      {AlertModalShow ? (
        <AlertModal
          show={AlertModalShow}
          onHide={() => setAlertModalShow(false)}
          AlertModalTitle={AlertModalTitle}
          AlertModalMessage={AlertModalMessage}
          AlertModalButtons={AlertModalButtons}
        />
      ) : null}
      <FillIdleTimeModal
        show={fillIdleShow}
        onHide={closeFillIdleTime}
        dayLabel={fillIdleDayLabel}
        remainingMinutes={fillIdleRemainingMinutes}
        candidates={fillIdleCandidates}
        onAdd={handleAddFillPlace}
      />
      {ShowMultiselect ? (
        <MultiSelectModal
          show={ShowMultiselect}
          onHide={() => setShowMultiselect(false)}
          MultiselectItems={MultiselectItems}
          MultiselectSelectedItems={MultiselectSelectedItems}
          MultiselectMode={MultiselectMode}
          MultiselectCallback={chooseScheduleCallBack}
          MultiselectTitle={MultiselectTitle}
          MultiselectSearchText={MultiselectSearchText}
        />
      ) : null}
      {ShowItinSettings && !ShowCoverImageDialog && (
        <div className="sh-itin-overlay" onClick={() => setShowItinSettings(false)}>
          <div className="sh-itin-modal" onClick={(e) => e.stopPropagation()}>
            <p className="sh-itin-title">Include in itinerary</p>
            {ItinAction === "copy" && (() => {
              const shown = CoverMode === "custom" && CoverCustomUrl ? CoverCustomUrl : getAutoCover();
              return (
                <div className="sh-itin-cover">
                  <div className="sh-itin-cover-preview">
                    {CoverMode !== "none" && shown ? (
                      <img src={Common.getImageURL(shown, null, true)} alt="Cover" referrerPolicy="no-referrer" />
                    ) : (
                      <span>{CoverMode === "none" ? "No cover image" : "No photo found"}</span>
                    )}
                  </div>
                  <div className="sh-itin-cover-side">
                    <span className="sh-itin-cover-label">Cover image</span>
                    <button
                      className="sh-itin-cover-btn"
                      onClick={() => { setCoverMode("custom"); setShowCoverImageDialog(true); }}
                    >
                      Change…
                    </button>
                    <div
                      className="sh-itin-check-row sh-itin-cover-none"
                      onClick={() => setCoverMode((m) => (m === "none" ? "auto" : "none"))}
                    >
                      <div className={`sh-itin-check-box${CoverMode === "none" ? " checked" : ""}`}>
                        {CoverMode === "none" && <FontAwesomeIcon icon={solid("check")} />}
                      </div>
                      <span className="sh-itin-check-label">No cover image</span>
                    </div>
                  </div>
                </div>
              );
            })()}
            {[
              { key: "place_name", label: "Place Name" },
              { key: "eventBody", label: "Event Description" },
              { key: "info", label: "Place Notes" },
              { key: "photo", label: "Place Photo" },
              { key: "directions", label: "Directions" },
              { key: "weather", label: "Weather" },
              { key: "climate", label: "Climate" },
            ].map(({ key, label }) => (
              <div
                key={key}
                className="sh-itin-check-row"
                onClick={() => setItinSettings((s) => ({ ...s, [key]: !s[key] }))}
              >
                <div className={`sh-itin-check-box${ItinSettings[key] ? " checked" : ""}`}>
                  {ItinSettings[key] && <FontAwesomeIcon icon={solid("check")} />}
                </div>
                <span className="sh-itin-check-label">{label}</span>
              </div>
            ))}
            <div className="sh-itin-actions">
              <button className="sh-itin-cancel" onClick={() => setShowItinSettings(false)}>Cancel</button>
              <button className="sh-itin-go" onClick={doItinerary}>
                {ItinAction === "copy" ? "Copy" : "Show"}
              </button>
            </div>
          </div>
        </div>
      )}
      {ShowCoverImageDialog && (
        <ImageDialog
          show={ShowCoverImageDialog}
          onHide={() => {
            setShowCoverImageDialog(false);
            // Closed without picking anything: fall back to the previous choice.
            setCoverMode((m) => (m === "custom" && !CoverCustomUrl ? "auto" : m));
          }}
          user_info={user_info}
          mode={"select"}
          modify_only={"true"}
          updateImage={(imageInfo) => {
            if (imageInfo && imageInfo[0]) {
              setCoverCustomUrl(imageInfo[0].url_m || imageInfo[0].url);
              setCoverMode("custom");
            }
          }}
          size={"sm"}
          photo={CoverCustomUrl || ""}
          photo_m={CoverCustomUrl || ""}
          multi={false}
          exif={false}
        />
      )}
    </div>
  );
};

export default ScheduleHeader;
